import { createFileRoute } from '@tanstack/react-router'
import { ProductGate } from '@bloo-team/core-shell'
import { IntegrationsTypePage } from '@bloo-team/product-synthai'

/** Composer shim (S5.0): Settings · Integrations · Catalog · one type, full page — @bloo-team/product-synthai, behind the SynthAI gate. */
function TypeRoute() {
  const { clusterId, scopeId, name } = Route.useParams()
  return (
    <ProductGate product="synthai" clusterId={clusterId} scopeId={scopeId}>
      <IntegrationsTypePage clusterId={clusterId} scopeId={scopeId} name={name} />
    </ProductGate>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/integrations/catalog/$name')({
  component: TypeRoute,
})
